import Vue from "vue";
import Vuex from "vuex";
import { api } from "@/services.js";

Vue.use(Vuex);

export const defaultFilters = {
  name: "",
  birthCountry: "all",
  ageFrom: "18",
  ageTo: "27",
  experiencedDriver: "all",
  infantCareQualified: "all",
  swimmer: "all",
  gender: "any",
  inCountry: "all",
};

const defaultUser = {
  id: "",
  role: "",
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
  city: "",
  state: "",
  zip: "",
  citizenOrResident: "",
  hasChildrenOrPlanTo: "",
  favoriteAuPairs: [],
};

export default new Vuex.Store({
  strict: true,
  state: {
    login: false,
    user: {
      id: "",
      role: "",
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      password: "",
      confirmPassword: "",
      city: "",
      state: "",
      zip: "",
      citizenOrResident: "",
      hasChildrenOrPlanTo: "",
      favoriteAuPairs: [],
      requestInterview: [],
      applicationLevel: "",
      match: "",
      matchRequest: null,
    },
    filters: {
      name: "",
      birthCountry: "all",
      ageFrom: "18",
      ageTo: "27",
      experiencedDriver: "all",
      infantCareQualified: "all",
      swimmer: "all",
      gender: "any",
      inCountry: "all",
    },
  },
  mutations: {
    UPDATE_LOGIN(state, payload) {
      state.login = payload;
    },
    UPDATE_USER(state, payload) {
      state.user = Object.assign(state.user, payload);
    },
    UPDATE_FILTER(state, payload) {
      state.filters = Object.assign(state.filters, payload);
    },
  },
  actions: {
    logUserIn(context, payload) {
      return api.login(payload).then((r) => {
        window.localStorage.CHIAuPairAuthToken = `Bearer ${r.data.content}`;
      });
    },

    resetUserPassword(context, payload) {
      return api.resetUserPassword(payload);
    },

    getUser(context) {
      return api.get("promotional/HostFamily/user").then((r) => {
        // if (
        //   r.data.hostFamilyStatus !== "A" &&
        //   r.data.hostFamilyStatus !== "I" &&
        //   r.data.hostFamilyStatus !== "R"
        // ) {
        //   window.localStorage.removeItem("CHIAuPairAuthToken");
        //   window.location.href = "https://ap2.chinet.org/";
        // }
        context.commit("UPDATE_USER", r.data);
        context.commit("UPDATE_LOGIN", true);
      });
    },
    createUser(payload) {
      return api.createHf(payload);
    },
    editUser(context) {
      return api.editHf(context.state.user);
    },

    logUserOut(context) {
      context.commit("UPDATE_USER", defaultUser);
      context.commit("UPDATE_LOGIN", false);
      window.localStorage.removeItem("CHIAuPairAuthToken");
      window.location.href = "https://ap2.chinet.org/login";
    },
    rememberPassword(context, payload) {
      return api.remember(payload);
    },

    //filter actions
    updateFilter(context) {
      window.localStorage.CHIAuPairFilters = JSON.stringify(
        context.state.filters
      );
      context.commit("UPDATE_FILTER", context.state.filters);
    },
    loadFilter(context) {
      let filters = JSON.parse(window.localStorage.getItem("CHIAuPairFilters"));
      context.commit("UPDATE_FILTER", filters);
    },
    clearFilter(context) {
      context.commit("UPDATE_FILTER", defaultFilters);
    },
    //data actions
    pullAuPairs(context, payload) {
      return api.post(payload.endpoint, context.state.filters);
    },
  },
  modules: {},
});
